module.exports = __webpack_public_path__ + "64a855fb45a1d5924a3a97b43ee530f4.png";